<mat-toolbar>
  <h1 class="changelog-title">Gyms change log</h1>
  @if (loading) {
    <mat-spinner [diameter]="30"></mat-spinner>
  }
</mat-toolbar>

<mat-card class="gymfinder-card change-log-container">
  <div class="flex-display filters">
    <mat-form-field class="form-column">
      <mat-label>Search by gym id</mat-label>
      <input
        #gymId
        matInput
        type="number"
        placeholder="Search by gym id"
        [(ngModel)]="egymGymId"
        (keydown.enter)="setGymIdFilter(gymId.value)" />
    </mat-form-field>
    <mat-form-field class="form-column">
      <mat-label>Change Source</mat-label>
      <mat-select [(ngModel)]="selectedSource" name="changSourceFilter">
        @for (source of changeSources; track source) {
          <mat-option
            [value]="source.value"
            (onSelectionChange)="onSourceChanged($event)"
            >{{ source.display }}</mat-option
          >
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="form-column">
      <mat-label>Review Status</mat-label>
      <mat-select
        multiple
        [(ngModel)]="selectedReviewStatus"
        name="reviewStatusFilter"
        disabled="{{ !selectedSource }}">
        @for (status of reviewStatuses; track status) {
          <mat-option
            [value]="status.value"
            (onSelectionChange)="onReviewStatusChanged($event)"
            disabled="{{ isStatusDisabled(status.value, selectedSource) }}"
            >{{ status.display }}</mat-option
          >
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="form-column">
      <mat-label>Network</mat-label>
      <mat-select
        multiple
        [(ngModel)]="selectedNetwork"
        name="networkFilter"
        (selectionChange)="onNetworkFilterChanged()">
        @for (ntw of networkFilterOptions; track ntw) {
          <mat-option [value]="ntw.value">{{ ntw.display }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="form-column">
      <mat-label>Field Type</mat-label>
      <mat-select
        multiple
        [(ngModel)]="selectedFieldTypes"
        name="fieldTypeFilter">
        @for (fieldType of fieldTypeOptions; track fieldType) {
          <mat-option
            [value]="fieldType.value"
            (onSelectionChange)="onFieldTypeChanged($event)">
            {{ fieldType.display }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (changeLogs.length) {
      <div class="clear-filters">
        <button mat-raised-button color="secondary" (click)="clearFilters()">
          Clear filters
        </button>
      </div>
    }
  </div>

  <mat-card-title class="changelog-subtitle">Changes</mat-card-title>

  @if (!changeLogs.length && !loading) {
    <div class="no-change-logs-wrapper">
      <span class="no-change-logs-title"
        >Sorry, we couldn't find any results.</span
      >
      <span class="no-change-logs-subtitle">
        Please try clearing your filters and try again
      </span>
      <button mat-raised-button color="primary" (click)="clearFilters()">
        Clear filters
      </button>
    </div>
  }

  <mat-card-content>
    <div class="change-log-table-container">
      @if (changeLogs.length) {
        <table mat-table [dataSource]="changeLogs" class="change-log-table">
          <ng-container matColumnDef="gymId">
            <th mat-header-cell *matHeaderCellDef>Gym ID</th>
            <td mat-cell *matCellDef="let element">{{ element.gymId }}</td>
          </ng-container>
          <ng-container matColumnDef="gymName">
            <th mat-header-cell *matHeaderCellDef>Gym Name</th>
            <td mat-cell *matCellDef="let element">{{ element.gymName }}</td>
          </ng-container>
          <ng-container matColumnDef="event">
            <th mat-header-cell *matHeaderCellDef>Event</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="change-log-event"
              matTooltip="{{ element.formattedFields }}"
              [matTooltipDisabled]="!showTooltip(element.formattedFields)"
              matTooltipClass="change-log-event-tooltip"
              (click)="openChangelogDialog(element)"
              (keydown)="openChangelogDialog(element)">
              {{ element.formattedFields }}
            </td>
          </ng-container>
          <ng-container matColumnDef="when">
            <th mat-header-cell *matHeaderCellDef>When</th>
            <td mat-cell *matCellDef="let element">
              {{ element.formattedCreatedAt }}
            </td>
          </ng-container>
          <ng-container matColumnDef="reviewStatus">
            <th mat-header-cell *matHeaderCellDef>Review Status</th>
            <td
              mat-cell
              *matCellDef="let element"
              [ngClass]="greyOutSource(element.source) ? 'greyed-out' : ''">
              {{ element.formattedReviewStatus }}
            </td>
          </ng-container>
          <ng-container matColumnDef="who" class="small-column">
            <th mat-header-cell *matHeaderCellDef>Who</th>
            <td mat-cell *matCellDef="let element">
              {{ element.modifiedBy }}
            </td>
          </ng-container>
          <ng-container matColumnDef="changeSource">
            <th mat-header-cell *matHeaderCellDef>Change Source</th>
            <td mat-cell *matCellDef="let element">
              {{ element.formattedSource }}
            </td>
          </ng-container>
          <ng-container matColumnDef="network">
            <th mat-header-cell *matHeaderCellDef>Network</th>
            <td mat-cell *matCellDef="let element">
              {{ element.formattedNetwork }}
            </td>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns"
            class="change-log-header"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="change-log-row"></tr>
        </table>
      }
    </div>

    <mat-paginator
      [ngClass]="[changeLogs.length ? 'changelog-paginator' : 'not-visible']"
      [pageSizeOptions]="[10, 50, 100]"
      [length]="totalCount"
      [pageSize]="defaultLimit" />
  </mat-card-content>
</mat-card>
